module.exports = __webpack_public_path__ + "static/img/manminibags.7802c8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/manminibags.jpg
// module id = Go3T
// module chunks = 1